// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"Auth_layoutWrapper__1bewb","blur":"Auth_blur__3w3T2","main":"Auth_main__2RbOK","footer":"Auth_footer__1xnIT"};